<!--
<div style="text-align: center; cursor: pointer" (click)="onClick()">
  <i *ngIf="cbValue" class="check circle outline icon"></i>
  <i *ngIf="!cbValue" class="circle outline icon"></i>
</div>
-->
<div style="text-align: center;">
  <div style="cursor: pointer; vertical-align: middle;"  class="ui checkbox" (click)="onClick()">
    <input type="checkbox" [checked]="cbValue">
    <div class="box"></div>
  </div>
</div>
